(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hotspot"] && !Shopify.designMode) return;
  try {
    
(function () {

  /* ════════════════════════════════════════════════
     SLIDER  (with mouse + touch drag)
  ════════════════════════════════════════════════ */
  document.querySelectorAll('.hotspot-slider').forEach(function (slider) {
    var id      = slider.dataset.sliderId;
    var track   = document.getElementById('hotspot-track-' + id.replace('hotspot-', ''));
    if (!track) return;

    var slides   = track.querySelectorAll('.hotspot-slide');
    var total    = slides.length;
    var current  = 0;
    var perView  = getPerView();
    var maxIndex = Math.max(0, total - perView);
    var prevBtn  = document.querySelector('.hotspot-slider__arrow--prev[data-slider-id="' + id + '"]');
    var nextBtn  = document.querySelector('.hotspot-slider__arrow--next[data-slider-id="' + id + '"]');

    /* ── helpers ── */
    function getPerView() {
      var w = window.innerWidth;
      if (w <= 480)  return 1;
      if (w <= 768)  return 2;
      if (w <= 1024) return 3;
      return 4;
    }

    function slideWidth() {
      return slides[0] ? slides[0].offsetWidth + 6 : 0; // 6 = gap
    }

    function goTo(idx) {
      current = Math.max(0, Math.min(idx, maxIndex));
      track.style.transform = 'translateX(-' + (current * slideWidth()) + 'px)';
      if (prevBtn) prevBtn.disabled = current === 0;
      if (nextBtn) nextBtn.disabled = current >= maxIndex;
    }

    /* ── arrow buttons ── */
    if (prevBtn) { prevBtn.addEventListener('click', function () { goTo(current - 1); }); prevBtn.disabled = true; }
    if (nextBtn) { nextBtn.addEventListener('click', function () { goTo(current + 1); }); }

    window.addEventListener('resize', function () {
      perView  = getPerView();
      maxIndex = Math.max(0, total - perView);
      goTo(Math.min(current, maxIndex));
    });

    /* ── drag / swipe ── */
    var dragStartX   = 0;
    var dragStartY   = 0;
    var dragDeltaX   = 0;
    var isDragging   = false;
    var isScrolling  = null;   // null = undecided, true = vertical scroll, false = horizontal drag
    var dragThreshold = 5;     // px before we decide direction
    var swipeMin      = 40;    // px to trigger slide change

    function dragStart(clientX, clientY) {
      dragStartX  = clientX;
      dragStartY  = clientY;
      dragDeltaX  = 0;
      isDragging  = true;
      isScrolling = null;
      track.classList.add('is-dragging');
      slider.style.cursor = 'grabbing';
    }

    function dragMove(clientX, clientY, e) {
      if (!isDragging) return;

      var dx = clientX - dragStartX;
      var dy = clientY - dragStartY;

      /* decide axis on first meaningful move */
      if (isScrolling === null && (Math.abs(dx) > dragThreshold || Math.abs(dy) > dragThreshold)) {
        isScrolling = Math.abs(dy) > Math.abs(dx);
      }

      if (isScrolling) {
        /* vertical scroll — bail out and let the browser handle it */
        dragEnd();
        return;
      }

      if (isScrolling === false) {
        e.preventDefault();   /* prevent page scroll while dragging horizontally */
        dragDeltaX = dx;
        var base = current * slideWidth();
        track.style.transform = 'translateX(-' + (base - dragDeltaX) + 'px)';
      }
    }

    function dragEnd() {
      if (!isDragging) return;
      isDragging = false;
      track.classList.remove('is-dragging');
      slider.style.cursor = '';

      if (isScrolling === false) {
        /* snap to slide */
        if (dragDeltaX < -swipeMin) {
          goTo(current + 1);
        } else if (dragDeltaX > swipeMin) {
          goTo(current - 1);
        } else {
          goTo(current); /* snap back */
        }
      }
      dragDeltaX  = 0;
      isScrolling = null;
    }

    /* mouse events */
    slider.addEventListener('mousedown', function (e) {
      if (e.button !== 0) return;
      dragStart(e.clientX, e.clientY);
    });
    window.addEventListener('mousemove', function (e) {
      dragMove(e.clientX, e.clientY, e);
    });
    window.addEventListener('mouseup', dragEnd);

    /* touch events */
    slider.addEventListener('touchstart', function (e) {
      dragStart(e.touches[0].clientX, e.touches[0].clientY);
    }, { passive: true });
    slider.addEventListener('touchmove', function (e) {
      dragMove(e.touches[0].clientX, e.touches[0].clientY, e);
    }, { passive: false });
    slider.addEventListener('touchend', dragEnd);

    /* initial render */
    slider.style.cursor = 'grab';
    goTo(0);
  });


  /* ════════════════════════════════════════════════
     HOTSPOT PINS
  ════════════════════════════════════════════════ */
  function closeAllPopups() {
    document.querySelectorAll('.hotspot-popup.is-visible').forEach(function (p) {
      p.classList.remove('is-visible');
    });
    document.querySelectorAll('.hotspot-pin.is-active').forEach(function (p) {
      p.classList.remove('is-active');
    });
  }

  document.querySelectorAll('.hotspot-pin').forEach(function (pin) {
    pin.addEventListener('click', function (e) {
      e.stopPropagation();
      var slideId = pin.dataset.slideId;
      var pinIdx  = pin.dataset.pinIndex;
      var popup   = document.getElementById('popup-' + slideId + '-' + pinIdx);
      if (!popup) return;

      var isOpen = popup.classList.contains('is-visible');
      closeAllPopups();

      if (!isOpen) {
        pin.classList.add('is-active');
        popup.classList.remove('flip-down');

        var pinTopPct = parseFloat(pin.style.top);
        if (pinTopPct < 30) popup.classList.add('flip-down');

        popup.classList.add('is-visible');
      }
    });
  });

  document.addEventListener('click', function (e) {
    if (!e.target.closest('.hotspot-popup') && !e.target.closest('.hotspot-pin')) {
      closeAllPopups();
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeAllPopups();
  });

})();

  } catch(e) { console.error(e); }
})();
})();
